import React from "react";
import { connect } from "react-redux";
import { Navigate } from "react-router-dom";
import { selectUsesGiveSpark } from "../../../utils/giveSpark";

interface Props {
  usesGiveSpark: boolean;
  redirectTo: string;
  children: React.ReactElement;
}

/** Renders its children only for GiveSpark charities; otherwise redirects to `redirectTo`. */
const RequireGiveSpark = ({ usesGiveSpark, redirectTo, children }: Props) =>
  usesGiveSpark ? children : <Navigate to={redirectTo} replace />;

export default connect(state => ({ usesGiveSpark: selectUsesGiveSpark(state) }))(
  RequireGiveSpark
);
